import { Type } from 'class-transformer';
import { CommunitySoaRequestRawDto } from './community-soa-request-raw-dto';

export class ConveyanceCommunitySoaRequestsRawDto {
    @Type(() => CommunitySoaRequestRawDto)
    communitySOARequest: CommunitySoaRequestRawDto[];
}
